import IconHelpButtonClose from '../../src/legacy/IconHelpButtonClose.tsx';
export default IconHelpButtonClose;
